import * as type from '../mutation-types'
import moment from 'moment'

const state = {}

const getters = {}

const actions = {}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/utilities.js